import { BaseConfig } from "../config.interface";
import { Size } from "../util";

interface ITagConfig {
    size: Size | "full";
}
export class TagConfig extends BaseConfig<ITagConfig> implements ITagConfig {
    size: Size | "full";


    /**
     * @theme Base
     */
    static baseTheme = {
        Default: new TagConfig({
            size: "full",
        }),
    };
}